import React, { useEffect } from 'react';

import { useIntl } from 'react-intl-next';

import Avatar from '@atlaskit/avatar';
import { fg } from '@atlaskit/platform-feature-flags';
import { Text } from '@atlaskit/primitives/compiled';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { Header as AtlaskitHeader, SkeletonItem } from '@atlaskit/side-navigation';
import { assert, AssertionError, isServer } from '@atlassian/eoc-common';
import { useResource } from '@atlassian/eoc-rrr-helpers';

import { teamResource } from '../../../services/resources';

import messages from './messages';

export const Header = () => {
	const { data, loading, error, clear } = useResource(teamResource);
	const { formatMessage } = useIntl();

	useEffect(() => {
		return () => {
			clear();
		};
	}, [clear]);

	if (loading || isServer()) {
		return (
			<UFOLoadHold name="eoc-team-dashboard-header-loading">
				<SkeletonItem hasIcon isShimmering testId="loader" />
			</UFOLoadHold>
		);
	}

	if (error) {
		return <SkeletonItem hasIcon isShimmering testId="loader" />;
	}

	assert(
		!loading && !!data,
		new AssertionError('Sidebar', 'There was an error while fetching team information'),
	);

	return (
		<AtlaskitHeader
			iconBefore={<Avatar borderColor="transparent" size="small" src={data.avatarImageUrl} />}
			description={
				fg('alx-9605_fix_color-contrast_issues') ? (
					<Text color="color.text.subtlest" size="UNSAFE_small">
						{formatMessage(messages.description)}
					</Text>
				) : (
					formatMessage(messages.description)
				)
			}
		>
			{data.name}
		</AtlaskitHeader>
	);
};
